import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "@/style/template.less";
import routeTo from "@/components/buttoncard/RouterLink.vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .component("routeTo", routeTo)
  .mount("#app");
